import axios from "../../axios-instance";
import Modal from "../modal/Modal";
import ModalButtonsConfig from "../modal/ModalButtonsConfig";
import {createFormData} from "../helpers/form-data-helper";

let currentTab = null;

const loadClientAzureActivities = (azureData) => {
  if (azureData.azure_restore_enabled && !azureData.isAxcient) {
    axios.get(`/client/get_azure_jobs/${azureData.clientId}`).then(response => {
      if (response.data.azure_jobs.length > 0) {
        showAzureActivities(response, azureData, true);
      }
    });
  }
};

const loadResellerAzureActivities = (azureData) => {
  if (azureData.azure_restore_enabled && !azureData.isAxcient) {
    axios.get(`/reseller/get_azure_jobs/${azureData.resellerId}`).then(response => {
      if (response.data.azure_jobs.length > 0) {
        showAzureActivities(response, azureData, false);
      }
    });
  }
};

const showAzureActivities = (response, azureData, isClientPage) => {
  const tab = getCurrentTab(azureData, isClientPage);
  currentTab = tab;
  const azureActivitiesHtml = Handlebars.compile(atob(azureData.azureActivitiesTemplate))({
    inProgressJobsCount: response.data.in_progress_jobs_count,
    completedJobsCount: response.data.completed_jobs_count,
    azureJobs: response.data.azure_jobs,
  });
  const activitiesTable = document.querySelector(`${tab} .feed-table-interest`);
  if (activitiesTable) {
    activitiesTable.insertAdjacentHTML('afterbegin', azureActivitiesHtml);
    initViewDetailsLinks();
  }

  const nothingRecent = document.querySelector(`${tab} .feed-table-interest .nothingrecent`);
  if (nothingRecent) {
    nothingRecent.remove();
  }

  const activities = activitiesTable.querySelectorAll(`.feed-row`);
  if (activities.length > 0) {
    const activitiesHeader = document.querySelector(`${tab} .collapsible-feed .header.pointer`);
    if (activitiesHeader) {
      activitiesHeader.classList.add('expanded');
    }

    activitiesTable.style.display = '';
  }
};

const getCurrentTab = (azureData, isClientPage) => {
  if (azureData.isReseller) {
    return isClientPage ? '#clients-tab' : '#reseller-dashboard-tab';
  } else {
    return '';
  }
};

const initViewDetailsLinks = () => {
  document.querySelectorAll('.js-azure-job-details').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const jobId = e.target.dataset.id;
      axios.get(`/azure_export/job_details/${jobId}`).then(response => {
        if (response.data) {
          openJobDetailsModal(response.data);
        }
      });
    });
  });
};

const openJobDetailsModal = (job) => {
  const modalDialog = new Modal();
  const modalContent = document.createElement("div");
  modalContent.className = "modal-dialog-details";
  let elementValue = null;

  job.blocks.forEach(block => {
    const blockElement = document.createElement("div");
    blockElement.className = "details-block";

    const blockTitle = document.createElement("div");
    blockTitle.className = "title";
    blockTitle.innerText = block.title;
    blockElement.appendChild(blockTitle);

    const elementsContainer = document.createElement("div");
    elementsContainer.className = "elements-container";

    block.elements.forEach(element => {
      const elementItem = document.createElement("div");
      elementItem.className = "block-element";

      if (element.isError) {
        elementItem.classList.add("full-width")
        elementValue = document.createElement("axs-code-block");
        elementValue.classList.add("error-element-container")
        elementValue.setAttribute("classes","error-element")
        elementValue.innerText = element.value;
      } else {
        const elementTitle = document.createElement("div");
        elementTitle.className = "label";
        elementTitle.innerText = element.title;
        elementItem.appendChild(elementTitle);
        elementValue = document.createElement("div");
        elementValue.className = "value";
        elementValue.innerText = element.value;
      }
      elementItem.appendChild(elementValue);
      elementsContainer.appendChild(elementItem);
    });
    blockElement.appendChild(elementsContainer);

    modalContent.appendChild(blockElement);
  });

  const primaryButtonHandler = () => {
    modalDialog.close();
  };

  const secondaryButtonHandler = () => {
    if (job.canCancel) {
      openCancelJobModal(job, modalDialog);
    } else if (job.canDismiss) {
      openDismissModal(job, modalDialog);
    }
  };

  const buttonsConfig = new ModalButtonsConfig(job.buttons.primary, job.buttons.secondary ?? null,
    primaryButtonHandler, job.buttons.secondary ? secondaryButtonHandler : null
  );


  modalDialog.render(job.header, modalContent, buttonsConfig);
};

const openCancelJobModal = (job, detailsModal) => {
  detailsModal.setVisible(false);
  const confirmModal = new Modal();
  const modalContent = document.createElement("div");
  modalContent.className = "modal-dialog-confirm";

  const confirmBlockTitle = document.createElement("div");
  confirmBlockTitle.className = "confirm-title";
  confirmBlockTitle.innerText = job.cancel.blockTitle;
  modalContent.appendChild(confirmBlockTitle);

  const confirmBlockText = document.createElement("div");
  confirmBlockText.className = "confirm-text";
  confirmBlockText.innerText = job.cancel.blockText;
  modalContent.appendChild(confirmBlockText);

  const primaryButtonHandler = () => {
    confirmModal.setPrimaryButtonDisabled(true)
    confirmModal.setSecondaryButtonDisabled(true);
    axios.post(`/azure_export/cancel_azure_job`, createFormData({
        job_id: job.jobId
      })
    ).then(response => {
      axios.get(`/azure_export/get_job_info/${job.jobId}`).then(response => {
        const exportRow = document.querySelector(`${currentTab} .azure-export-row-${job.jobId}`);
        if (exportRow) {
          exportRow.querySelector('.column-status').innerText = response.data.status;
          exportRow.querySelector('.column-finish-time').innerText = response.data.finish_time;
        }
        confirmModal.close();
        detailsModal.close();
      });
    }).catch(error => {
      confirmModal.setPrimaryButtonDisabled(false)
      confirmModal.setSecondaryButtonDisabled(false);
    });
  };

  const secondaryButtonHandler = () => {
    confirmModal.close();
    detailsModal.setVisible(true);
  };

  const buttonsConfig = new ModalButtonsConfig(job.cancel.buttons.primary, job.cancel.buttons.secondary,
    primaryButtonHandler, secondaryButtonHandler);

  confirmModal.render(job.cancel.header, modalContent, buttonsConfig);
};

const openDismissModal = (job, detailsModal) => {
  detailsModal.setVisible(false);
  const confirmModal = new Modal();
  const modalContent = document.createElement("div");
  modalContent.className = "modal-dialog-confirm";

  const confirmBlockTitle = document.createElement("div");
  confirmBlockTitle.className = "confirm-title";
  confirmBlockTitle.innerText = job.dismiss.blockTitle;
  modalContent.appendChild(confirmBlockTitle);

  const confirmBlockText = document.createElement("div");
  confirmBlockText.className = "confirm-text";
  confirmBlockText.innerHTML = job.dismiss.blockText;
  modalContent.appendChild(confirmBlockText);

  const confirmBlockNote = document.createElement("div");
  confirmBlockNote.className = "confirm-note";
  confirmBlockNote.innerText = job.dismiss.blockNote;
  modalContent.appendChild(confirmBlockNote);

  const primaryButtonHandler = () => {
    confirmModal.setPrimaryButtonDisabled(true)
    confirmModal.setSecondaryButtonDisabled(true);
    axios.post(`/azure_export/dismiss_azure_job`, createFormData({
        job_id: job.jobId
      })
    ).then(response => {
      const exportRow = document.querySelector(`${currentTab} .azure-export-row-${job.jobId}`);
      if (exportRow) {
        exportRow.remove();
        const rowsCount = document.querySelectorAll(`${currentTab} .azure-exports .azure-job`).length;
        if (rowsCount === 0) {
          document.querySelector(`${currentTab} .azure-exports`).remove();
        }
      }
      const completedJobsItem = document.querySelector(`${currentTab} .azure-exports .completed-count`);
      if (completedJobsItem) {
        completedJobsItem.innerText = parseInt(completedJobsItem.innerText) - 1;
      }
      confirmModal.close();
      detailsModal.close();
    }).catch(error => {
      confirmModal.setPrimaryButtonDisabled(false)
      confirmModal.setSecondaryButtonDisabled(false);
    });
  };

  const secondaryButtonHandler = () => {
    confirmModal.close();
    detailsModal.setVisible(true);
  };

  const buttonsConfig = new ModalButtonsConfig(job.dismiss.buttons.primary, job.dismiss.buttons.secondary,
    primaryButtonHandler, secondaryButtonHandler);

  confirmModal.render(job.dismiss.header, modalContent, buttonsConfig);
};

export { loadClientAzureActivities, loadResellerAzureActivities };
